/** Shared contracts between API and web — keep thin; expand with Zod later. */
/** Minimum password length (login + change). */
export const PASSWORD_MIN_LENGTH = 6;
export const APP_NAME = 'Unarvu Cloud Connect';
export const APP_SHORT = 'UCC';
/** Demo accounts for local MVP (API seeds the same set). */
export const DEV_DEMO_ACCOUNTS = [
    {
        email: 'admin@unarvu.local',
        password: 'admin123',
        role: 'admin',
        label: 'Platform admin',
    },
    {
        email: 'user@unarvu.local',
        password: 'user123',
        role: 'user',
        label: 'Tenant operator',
    },
    {
        email: 'client@unarvu.local',
        password: 'client123',
        role: 'client',
        label: 'Client viewer',
    },
];
//# sourceMappingURL=index.js.map